import * as Rollbar from 'rollbar';
import { InjectionToken } from '@angular/core';
import { environment } from 'environments/environment';

export function getRollbarConfig(): Rollbar.Configuration {
  return {
    enabled: environment.production,
    accessToken: '9c7f7629dcda46bdb043fb458cace174',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      client: {
        javascript: {
          code_version: environment.rollbarCodeVersion,
        },
      },
    },
  }
}

export function rollbarFactory() {
  return new Rollbar(getRollbarConfig());
}

export const RollbarServiceToken = new InjectionToken<Rollbar>('rollbar');
